import axios from 'axios';

import { addNotification, NotificationImportance } from '../common/commonActions';

/**
 * Liste des actions
 */
export const Actions = {
    INIT_DETAILS_RECLAMATION: 'INIT_DETAILS_RECLAMATION',

    FETCH_RECLAMATION_REQUEST: 'FETCH_RECLAMATION_REQUEST',
    FETCH_RECLAMATION_SUCCESS: 'FETCH_RECLAMATION_SUCCESS',
    FETCH_RECLAMATION_FAILURE: 'FETCH_RECLAMATION_FAILURE',

    FETCH_RECLAMATION_OBSERVATEURS_REQUEST: 'FETCH_RECLAMATION_OBSERVATEURS_REQUEST',
    FETCH_RECLAMATION_OBSERVATEURS_SUCCESS: 'FETCH_RECLAMATION_OBSERVATEURS_SUCCESS',
    FETCH_RECLAMATION_OBSERVATEURS_FAILURE: 'FETCH_RECLAMATION_OBSERVATEURS_FAILURE',

    ADD_RECLAMATION_OBSERVATEUR_SUCCESS: 'ADD_RECLAMATION_OBSERVATEUR_SUCCESS',
    ADD_RECLAMATION_OBSERVATEUR_FAILURE: 'ADD_RECLAMATION_OBSERVATEUR_FAILURE',

    REMOVE_RECLAMATION_OBSERVATEUR_SUCCESS: 'REMOVE_RECLAMATION_OBSERVATEUR_SUCCESS',
    REMOVE_RECLAMATION_OBSERVATEUR_FAILURE: 'REMOVE_RECLAMATION_OBSERVATEUR_FAILURE',

    FETCH_RECLAMATION_QUALIFICATIONS_REQUEST: 'FETCH_RECLAMATION_QUALIFICATIONS_REQUEST',
    FETCH_RECLAMATION_QUALIFICATIONS_SUCCESS: 'FETCH_RECLAMATION_QUALIFICATIONS_SUCCESS',
    FETCH_RECLAMATION_QUALIFICATIONS_FAILURE: 'FETCH_RECLAMATION_QUALIFICATIONS_FAILURE',
    INVALIDATE_RECLAMATION_QUALIFICATIONS: 'INVALIDATE_RECLAMATION_QUALIFICATIONS',

    FETCH_RECLAMATION_INFOS_GENERALES_REQUEST: 'FETCH_RECLAMATION_INFOS_GENERALES_REQUEST',
    FETCH_RECLAMATION_INFOS_GENERALES_SUCCESS: 'FETCH_RECLAMATION_INFOS_GENERALES_SUCCESS',
    FETCH_RECLAMATION_INFOS_GENERALES_FAILURE: 'FETCH_RECLAMATION_INFOS_GENERALES_FAILURE',
    INVALIDATE_RECLAMATION_INFOS_GENERALES: 'INVALIDATE_RECLAMATION_INFOS_GENERALES',

    FETCH_RECLAMATION_INFOS_LOGISTIQUE_REQUEST: 'FETCH_RECLAMATION_INFOS_LOGISTIQUE_REQUEST',
    FETCH_RECLAMATION_INFOS_LOGISTIQUE_SUCCESS: 'FETCH_RECLAMATION_INFOS_LOGISTIQUE_SUCCESS',
    FETCH_RECLAMATION_INFOS_LOGISTIQUE_FAILURE: 'FETCH_RECLAMATION_INFOS_LOGISTIQUE_FAILURE',
    INVALIDATE_RECLAMATION_INFOS_LOGISTIQUE: 'INVALIDATE_RECLAMATION_INFOS_LOGISTIQUE',

    FETCH_RECLAMATION_HISTORIQUE_REQUEST: 'FETCH_RECLAMATION_HISTORIQUE_REQUEST',
    FETCH_RECLAMATION_HISTORIQUE_SUCCESS: 'FETCH_RECLAMATION_HISTORIQUE_SUCCESS',
    FETCH_RECLAMATION_HISTORIQUE_FAILURE: 'FETCH_RECLAMATION_HISTORIQUE_FAILURE',
    INVALIDATE_RECLAMATION_HISTORIQUE: 'INVALIDATE_RECLAMATION_HISTORIQUE',

    FETCH_INFOS_DEMANDE_ENLEVEMENT_REQUEST: 'FETCH_INFOS_DEMANDE_ENLEVEMENT_REQUEST',
    FETCH_INFOS_DEMANDE_ENLEVEMENT_SUCCESS: 'FETCH_INFOS_DEMANDE_ENLEVEMENT_SUCCESS',
    FETCH_INFOS_DEMANDE_ENLEVEMENT_FAILURE: 'FETCH_INFOS_DEMANDE_ENLEVEMENT_FAILURE',

    FETCH_INFOS_ACTION_MAGASIN_REQUEST: 'FETCH_INFOS_ACTION_MAGASIN_REQUEST',
    FETCH_INFOS_ACTION_MAGASIN_SUCCESS: 'FETCH_INFOS_ACTION_MAGASIN_SUCCESS',
    FETCH_INFOS_ACTION_MAGASIN_FAILURE: 'FETCH_INFOS_ACTION_MAGASIN_FAILURE',

    FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_REQUEST: 'FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_REQUEST',
    FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_SUCCESS: 'FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_SUCCESS',
    FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_FAILURE: 'FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_FAILURE'
};

/**
 * INIT_DETAILS_RECLAMATION
 * ActionCreator pour réinitialiser le reducer afin de permettre le rechargement de la page de détail.
 */
export const initDetailsReclamation = () => ({ type: Actions.INIT_DETAILS_RECLAMATION });

/**
 * FETCH_RECLAMATION
 * ActionCreator pour la récuperation d'une réclamation
 */
const fetchReclamationRequest = () => ({ type: Actions.FETCH_RECLAMATION_REQUEST });
const fetchReclamationSuccess = reclamation => ({ type: Actions.FETCH_RECLAMATION_SUCCESS, reclamation });
const fetchReclamationFailure = error => ({ type: Actions.FETCH_RECLAMATION_FAILURE, error });

export const fetchReclamation = (id) => async (dispatch, getState) => {

    if (!getState().reclamation.details.isLoading) {
        dispatch(fetchReclamationRequest());

        try {
            let response = await axios.get(`api/reclamations/${id}`);
            dispatch(fetchReclamationSuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 404) {
                //dispatch(replace('/404'));
            }

            console.error('fetchReclamation : ', error);
            dispatch(fetchReclamationFailure(error));
        }
    }
};

export const fetchReclamationExist = async (id) => {

    try {
        await axios.head(`api/reclamations/${id}`);
        return true;
    } catch (error) {
        return false;
    }
};


/**
 * FETCH_RECLAMATION_OBSERVATEURS
 * ActionCreator pour la récuperation des observateurs d'une réclamation
 */
const fetchReclamationObservateursRequest = () => ({ type: Actions.FETCH_RECLAMATION_OBSERVATEURS_REQUEST });
export const fetchReclamationObservateursSuccess = observateurs => ({ type: Actions.FETCH_RECLAMATION_OBSERVATEURS_SUCCESS, observateurs });
const fetchReclamationObservateursFailure = error => ({ type: Actions.FETCH_RECLAMATION_OBSERVATEURS_FAILURE, error });

export const fetchReclamationObservateurs = (id) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isObservateursLoading && !getState().reclamation.details.isLoading) {
        dispatch(fetchReclamationObservateursRequest());

        try {
            let response = await axios.get(`api/reclamations/${id}/observateurs`);
            dispatch(fetchReclamationObservateursSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamationObservateurs : ', error);
            dispatch(fetchReclamationObservateursFailure(error));
        }
    }
};


/**
 * ADD_RECLAMATION_OBSERVATEUR
 * ActionCreator pour ajouter un observateur d'une réclamation
 */
const addReclamationObservateurSuccess = () => ({ type: Actions.ADD_RECLAMATION_OBSERVATEUR_SUCCESS });
const addReclamationObservateurFailure = error => ({ type: Actions.ADD_RECLAMATION_OBSERVATEUR_FAILURE, error });

export const addReclamationObservateur = (reclamationId, utilisateurId) => async (dispatch) => {
    try {
        await axios.post(`api/reclamations/${reclamationId}/observateurs/${utilisateurId}`);
        dispatch(addNotification(`L'observateur a bien été ajouté.`, NotificationImportance.success));
        dispatch(addReclamationObservateurSuccess());
        dispatch(invalidateReclamationHistorique());
    } catch (error) {
        console.error('addReclamationObservateur : ', error);
        dispatch(addNotification(`Erreur lors de l'ajout de l'observateur.`, NotificationImportance.error));
        dispatch(addReclamationObservateurFailure(error));
    }
};


/**
 * REMOVE_RECLAMATION_OBSERVATEUR
 * ActionCreator pour supprimer un observateur d'une réclamation
 */
const removeReclamationObservateurSuccess = utilisateurId => ({ type: Actions.REMOVE_RECLAMATION_OBSERVATEUR_SUCCESS, utilisateurId });
const removeReclamationObservateurFailure = error => ({ type: Actions.REMOVE_RECLAMATION_OBSERVATEUR_FAILURE, error });

export const removeReclamationObservateur = (reclamationId, utilisateurId) => async (dispatch) => {
    try {
        await axios.delete(`api/reclamations/${reclamationId}/observateurs/${utilisateurId}`);
        dispatch(addNotification(`L'observateur a bien été supprimé.`, NotificationImportance.success));
        dispatch(removeReclamationObservateurSuccess(utilisateurId));
        dispatch(invalidateReclamationHistorique());
    } catch (error) {
        console.error('removeReclamationObservateur : ', error);
        dispatch(addNotification(`Erreur lors de la suppression de l'observateur.`, NotificationImportance.error));
        dispatch(removeReclamationObservateurFailure(error));
    }
};


/**
 * FETCH_RECLAMATION_QUALIFICATIONS
 * ActionCreator pour la récuperation des qualifications d'une réclamation
 */
const fetchReclamationQualificationsRequest = () => ({ type: Actions.FETCH_RECLAMATION_QUALIFICATIONS_REQUEST });
const fetchReclamationQualificationsSuccess = qualifications => ({ type: Actions.FETCH_RECLAMATION_QUALIFICATIONS_SUCCESS, qualifications });
const fetchReclamationQualificationsFailure = error => ({ type: Actions.FETCH_RECLAMATION_QUALIFICATIONS_FAILURE, error });
export const invalidateReclamationQualifications = () => ({ type: Actions.INVALIDATE_RECLAMATION_QUALIFICATIONS });

export const fetchReclamationQualifications = (id) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isQualificationsLoading/* && !getState().reclamation.details.isLoading*/) {
        dispatch(fetchReclamationQualificationsRequest());

        try {
            let response = await axios.get(`api/reclamations/${id}/qualifications`);
            dispatch(fetchReclamationQualificationsSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamationQualifications : ', error);
            dispatch(fetchReclamationQualificationsFailure(error));
        }
    }
};

const shouldFetchReclamationQualifications = (state) => {
    let isLoading = state.reclamation.details.isQualificationsLoading;
    let didInvalidate = state.reclamation.details.didQualificationsInvalidate;

    if (isLoading) return false;
    else return didInvalidate;
};

export const fetchReclamationQualificationsIfNeeded = (id) => (dispatch, getState) => {
    if (shouldFetchReclamationQualifications(getState())) {
        return dispatch(fetchReclamationQualifications(id));
    }
};


/**
 * FETCH_RECLAMATION_INFOS_GENERALES
 * ActionCreator pour la récuperation des infos générales d'une réclamation
 */
const fetchReclamationInfosGeneralesRequest = () => ({ type: Actions.FETCH_RECLAMATION_INFOS_GENERALES_REQUEST });
const fetchReclamationInfosGeneralesSuccess = infosGenerales => ({ type: Actions.FETCH_RECLAMATION_INFOS_GENERALES_SUCCESS, infosGenerales });
const fetchReclamationInfosGeneralesFailure = error => ({ type: Actions.FETCH_RECLAMATION_INFOS_GENERALES_FAILURE, error });
export const invalidateReclamationInfosGenerales = () => ({ type: Actions.INVALIDATE_RECLAMATION_INFOS_GENERALES });

export const fetchReclamationInfosGenerales = (id) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isInfosGeneralesLoading && !getState().reclamation.details.isLoading) {
        dispatch(fetchReclamationInfosGeneralesRequest());

        try {
            let response = await axios.get(`api/reclamations/${id}/infos-generales`);
            dispatch(fetchReclamationInfosGeneralesSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamationInfosGenerales : ', error);
            dispatch(fetchReclamationInfosGeneralesFailure(error));
        }
    }
};

const shouldFetchReclamationInfosGenerales = state => {
    let isLoading = state.reclamation.details.isInfosGeneralesLoading;
    let didInvalidate = state.reclamation.details.didInfosGeneralesInvalidate;

    if (isLoading) return false;
    else return didInvalidate;
};

export const fetchReclamationInfosGeneralesIfNeeded = (id) => (dispatch, getState) => {
    if (shouldFetchReclamationInfosGenerales(getState())) {
        return dispatch(fetchReclamationInfosGenerales(id));
    }
};


/**
 * FETCH_RECLAMATION_INFOS_LOGISTIQUE
 * ActionCreator pour la récuperation des infos logistique d'une réclamation
 */
const fetchReclamationInfosLogistiqueRequest = () => ({ type: Actions.FETCH_RECLAMATION_INFOS_LOGISTIQUE_REQUEST });
const fetchReclamationInfosLogistiqueSuccess = infosLogistique => ({ type: Actions.FETCH_RECLAMATION_INFOS_LOGISTIQUE_SUCCESS, infosLogistique });
const fetchReclamationInfosLogistiqueFailure = error => ({ type: Actions.FETCH_RECLAMATION_INFOS_LOGISTIQUE_FAILURE, error });
export const invalidateReclamationInfosLogistique = () => ({ type: Actions.INVALIDATE_RECLAMATION_INFOS_LOGISTIQUE });

export const fetchReclamationInfosLogistique = (id, pieceCle = null) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isInfosLogistiqueLoading && !getState().reclamation.details.isLoading) {
        dispatch(fetchReclamationInfosLogistiqueRequest());

        try {
            // pieceCle : BL ciblé pour un dossier multi-BL (depuis commande) ; null = première pièce.
            let response = await axios.get(`api/reclamations/${id}/infos-logistique`, {
                params: { pieceCle: pieceCle }
            });

            dispatch(fetchReclamationInfosLogistiqueSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamationInfosLogistique : ', error);
            dispatch(fetchReclamationInfosLogistiqueFailure(error));
        }
    }
};

const shouldFetchReclamationInfosLogistique = state => {
    let isLoading = state.reclamation.details.isInfosLogistiqueLoading;
    let didInvalidate = state.reclamation.details.didInfosLogistiqueInvalidate;

    if (isLoading) return false;
    else return didInvalidate;
};

export const fetchReclamationInfosLogistiqueIfNeeded = (id, pieceCle = null) => (dispatch, getState) => {
    if (shouldFetchReclamationInfosLogistique(getState())) {
        return dispatch(fetchReclamationInfosLogistique(id, pieceCle));
    }
};

/**
 * FETCH_RECLAMATION_HISTORIQUE
 * ActionCreator pour la récuperation de l'historique d'une réclamation
 */
const fetchReclamationHistoriqueRequest = () => ({ type: Actions.FETCH_RECLAMATION_HISTORIQUE_REQUEST });
const fetchReclamationHistoriqueSuccess = historique => ({ type: Actions.FETCH_RECLAMATION_HISTORIQUE_SUCCESS, historique });
const fetchReclamationHistoriqueFailure = error => ({ type: Actions.FETCH_RECLAMATION_HISTORIQUE_FAILURE, error });
export const invalidateReclamationHistorique = () => ({ type: Actions.INVALIDATE_RECLAMATION_HISTORIQUE });

export const fetchReclamationHistorique = (id) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isHistoriqueLoading && !getState().reclamation.details.isLoading) {
        dispatch(fetchReclamationHistoriqueRequest());

        try {
            let response = await axios.get(`api/reclamations/${id}/historique`);
            dispatch(fetchReclamationHistoriqueSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamationHistorique : ', error);
            dispatch(fetchReclamationHistoriqueFailure(error));
        }
    }
};

const shouldFetchReclamationHistorique = state => {
    let historique = state.reclamation.details.historique;
    let isLoading = state.reclamation.details.isHistoriqueLoading;
    let didInvalidate = state.reclamation.details.didHistoriqueInvalidate;
    
    if (isLoading) return false;    
    else if (!historique) return true;
    else return didInvalidate;
};

export const fetchReclamationHistoriqueIfNeeded = (id) => (dispatch, getState) => {
    if (shouldFetchReclamationHistorique(getState())) {
        return dispatch(fetchReclamationHistorique(id));
    }
};


/**
 * FETCH_INFOS_DEMANDE_ENLEVEMENT
 * ActionCreator pour récupérer les informations pour faire une demande d'enlèvement
 */
const fetchInfosDemandeEnlevementRequest = () => ({ type: Actions.FETCH_INFOS_DEMANDE_ENLEVEMENT_REQUEST });
const fetchInfosDemandeEnlevementSuccess = infos => ({ type: Actions.FETCH_INFOS_DEMANDE_ENLEVEMENT_SUCCESS, infos });
const fetchInfosDemandeEnlevementFailure = error => ({ type: Actions.FETCH_INFOS_DEMANDE_ENLEVEMENT_FAILURE, error });

export const fetchInfosDemandeEnlevement = (id) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isLoading) {
        dispatch(fetchInfosDemandeEnlevementRequest());

        try {
            let response = await axios.get(`api/reclamations/${id}/infos-demande-enlevement`);
            dispatch(fetchInfosDemandeEnlevementSuccess(response.data));
        } catch (error) {
            console.error('fetchInfosDemandeEnlevement : ', error);
            dispatch(fetchInfosDemandeEnlevementFailure(error));
        }
    }
};


/**
 * FETCH_INFOS_ACTION_MAGASIN
 * ActionCreator pour récupérer les informations pour faire une action magasin
 */
const fetchInfosActionMagasinRequest = () => ({ type: Actions.FETCH_INFOS_ACTION_MAGASIN_REQUEST });
const fetchInfosActionMagasinSuccess = infos => ({ type: Actions.FETCH_INFOS_ACTION_MAGASIN_SUCCESS, infos });
const fetchInfosActionMagasinFailure = error => ({ type: Actions.FETCH_INFOS_ACTION_MAGASIN_FAILURE, error });

export const fetchInfosActionMagasin = (id, details) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isLoading) {
        dispatch(fetchInfosActionMagasinRequest());
        
        try {
            let response = await axios.get(`api/reclamations/${id}/infos-action-magasin?details=${details}`);

            dispatch(fetchInfosActionMagasinSuccess(response.data));
        } catch (error) {
            console.error('fetchInfosActionMagasin : ', error);
            dispatch(fetchInfosActionMagasinFailure(error));
        }
    }
};





/**
 * FETCH_RECLAMATION_DEMANDES_ENLEVEMENT
 * ActionCreator pour récupérer les demandes d'enlevement pour un client depuis une réclamation
 */
const fetchReclamationDemandesEnlevementRequest = () => ({ type: Actions.FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_REQUEST });
const fetchReclamationDemandesEnlevementSuccess = infos => ({ type: Actions.FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_SUCCESS, infos });
const fetchReclamationDemandesEnlevementFailure = error => ({ type: Actions.FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_FAILURE, error });

export const fetchReclamationDemandesEnlevement = (reclamationId) => async (dispatch, getState) => {
    if (!getState().reclamation.details.demandesEnlevement.isLoading) {
        dispatch(fetchReclamationDemandesEnlevementRequest());

        try {
            let response = await axios.get(`api/reclamations/${reclamationId}/demandes-enlevement`);

            dispatch(fetchReclamationDemandesEnlevementSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamationDemandesEnlevement : ', error);
            dispatch(fetchReclamationDemandesEnlevementFailure(error));
        }
    }
};
